/* unplugin-vue-components disabled */import script from "./prod-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./prod-modal.vue?vue&type=script&setup=true&lang=js"

import "./prod-modal.vue?vue&type=style&index=0&id=623225e4&lang=scss"

const __exports__ = script;

export default __exports__